import * as types from '../../../types/masters/company/companyTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingCompany: null,
};

export default function companyReducer(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_COMPANIES_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_COMPANIES_SUCCESS':
      return { ...state, loading: false, list: action.payload };
    case 'FETCH_COMPANIES_FAILURE':
      return { ...state, loading: false, error: action.error };
    case types.ADD_COMPANY_SUCCESS:
      return { ...state, list: [...state.list, action.payload] };
    case types.UPDATE_COMPANY_SUCCESS:
      return {
        ...state,
        list: state.list.map(c => c.company_id === action.payload.company_id ? action.payload : c),
      };
    case types.DELETE_COMPANY_SUCCESS:
      return {
        ...state,
        list: state.list.filter(c => c.company_id !== action.payload),
      };
    case types.SET_COMPANY_EDIT:
      return { ...state, editingCompany: action.payload };
    case types.CLEAR_COMPANY_EDIT:
      return { ...state, editingCompany: null };
    default:
      return state;
  }
} 